type NonNullableArray<T extends unknown[]> = T extends Array<infer K | null | undefined>
  ? K[]
  : never;

/**
 * Filter `undefined`` and `null` values from an array
 *
 * The function returns a new array and does not mutate the original array.
 * The function also returns the proper type for the filtered array,
 * removing `null` and `undefined` types from it.
 *
 * Array<string | null | undefined> => Array<string>
 */
export function filterNullish<T extends unknown[]>(array: T): NonNullableArray<T> {
  return array.filter(a => a != null) as NonNullableArray<T>;
}
